import { useMutation, useQueryClient } from "@tanstack/react-query";
import { globalConfigServices } from "features/globalConfiguration/services/globalConfig.service";
import toast from "react-hot-toast";

export const useResetGlobalConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => globalConfigServices.resetGlobalConfig(),
    onSuccess: () => {
      queryClient.invalidateQueries(["globalConfig"]);
      toast.success("Global configuration reset to default successfully");
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.message || "Failed to reset global configuration"
      );
    },
  });
};